<div class="next-offers-presentation-dialog">

</div>
